import { useState } from "react";

import { InterventionSubitemsModal } from "components";
import { SubitemsTable } from "modules/AppointmentDetails/components/Interventions/components/Subitems/components/SubitemsTable";

import type { DealerLocation, InterventionElement } from "models";

type InterventionSubitemsProps = {
  showInterventionSubItemModal: boolean;
  interventionSubItems: InterventionElement[];
  location?: DealerLocation | null;
  formSetPrice: (price: number) => void;
  handleOpenSubitemsModal: () => void;
  handleCloseSubitemsModal: () => void;
  handleUpdateInterventionElements: (value: InterventionElement[]) => void;
};

export const InterventionSubitems = ({
  location,
  interventionSubItems,
  showInterventionSubItemModal,
  formSetPrice,
  handleOpenSubitemsModal,
  handleCloseSubitemsModal,
  handleUpdateInterventionElements
}: InterventionSubitemsProps) => {
  const [subItemToEdit, setSubItemToEdit] = useState<InterventionElement | null>(null);

  const handleAddSubitem = (element: InterventionElement) => {
    handleUpdateInterventionElements([...interventionSubItems, element]);
    handleCloseSubitemsModal();
  };

  const handleDeleteSubitem = (item: InterventionElement) => {
    const interventionSubItem = interventionSubItems.filter(subitem => subitem.dms_nr !== item.dms_nr);
    handleUpdateInterventionElements(interventionSubItem);

    if (interventionSubItem.length === 1) formSetPrice(Number(interventionSubItem[0].price));
  };

  const toggleEditSubitem = (item: InterventionElement) => {
    setSubItemToEdit(item);
    handleOpenSubitemsModal();
  };

  const handleEditSubitem = (element: InterventionElement) => {
    const subitemIdx = interventionSubItems.findIndex(subitem => subitem.dms_nr === subItemToEdit?.dms_nr);
    if (subitemIdx < 0 || !subItemToEdit) return;

    handleUpdateInterventionElements(interventionSubItems.with(subitemIdx, { ...subItemToEdit, ...element }));
    handleCloseSubitemsModal();
    setSubItemToEdit(null);
  };

  return (
    <>
      {showInterventionSubItemModal && (
        <InterventionSubitemsModal
          onSubmit={subItemToEdit ? handleEditSubitem : handleAddSubitem}
          element={subItemToEdit}
          onClose={handleCloseSubitemsModal}
          location={location}
        />
      )}

      {interventionSubItems.length > 0 && (
        <SubitemsTable onEdit={toggleEditSubitem} elements={interventionSubItems} onDeleteSubitem={handleDeleteSubitem} location={location} />
      )}
    </>
  );
};
